/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* ---------------------------------------------------------------------------
 * Auto-update cart quantities on the full cart page.
 *
 * The ajax-cart library replaces every input[type="number"] with a .js-qty
 * widget, so we must target .js-qty__num and .js-qty__adjust instead.
 * The +/- buttons call jQuery .val() which does NOT fire a change event,
 * so we hook the click event on the buttons as well.
 * --------------------------------------------------------------------------- */
(function () {
  // Only run on the full cart page
  function init() {
    var cartForm = document.querySelector(".cart-form");
    if (!cartForm) return;

    // Hide the manual "Update Cart" button — no longer needed
    var updateBtn = cartForm.querySelector(".cart__button-update");
    if (updateBtn) updateBtn.style.display = "none";

    var debounceTimer = null;
    var isUpdating = false;

    function collectQuantities() {
      var updates = {};
      // .js-qty__num is what the qty-selector template creates from the original inputs
      cartForm.querySelectorAll(".js-qty__num[data-id]").forEach(function (input) {
        var key = input.dataset.id;
        var qty = parseInt(input.value, 10);
        if (key) updates[key] = isNaN(qty) || qty < 0 ? 0 : qty;
      });
      return updates;
    }

    function showLoading() {
      isUpdating = true;
      cartForm.classList.add("cart-form--updating");
      if (cartForm.querySelector(".cart-form__overlay")) return;
      var overlay = document.createElement("div");
      overlay.className = "cart-form__overlay";
      overlay.innerHTML =
        '<div class="cart-form__spinner">' +
        '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">' +
        '<path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>' +
        "</svg></div>";
      cartForm.appendChild(overlay);
    }

    function hideLoading() {
      isUpdating = false;
      cartForm.classList.remove("cart-form--updating");
      var overlay = cartForm.querySelector(".cart-form__overlay");
      if (overlay) overlay.remove();
    }

    function sendUpdate() {
      if (isUpdating) return;
      var updates = collectQuantities();
      if (!Object.keys(updates).length) return;

      showLoading();

      fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ updates: updates })
      })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          hideLoading();
        });
    }

    function schedule() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(sendUpdate, 500);
    }

    // +/- button clicks — the js-qty handler calls .val() internally (no change
    // event), so we wait one tick for it to finish before scheduling the update.
    document.addEventListener("click", function (event) {
      var btn = event.target.closest(".js-qty__adjust");
      if (btn && cartForm.contains(btn)) {
        setTimeout(schedule, 30);
      }
    });

    // Direct typing into the qty field — fires on blur/Enter
    document.addEventListener("change", function (event) {
      if (event.target.matches(".js-qty__num") && cartForm.contains(event.target)) {
        schedule();
      }
    });
  }

  // Run after DOM is ready (ajax-cart replaces inputs on DOMContentLoaded)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

$("#carouselTimeline").on('slide.bs.carousel', function (evt) {
    //Mobile dropdown menu
    $('.about-section-1 .dropdown .dropdown-item').removeClass('active');
    var ele = $(".about-section-1 .dropdown .dropdown-item")[$(this).find('.active').index() - 1];
    console.log(ele);
    $(ele).addClass('active');
    var text = $(ele).text();
    $("about-section-1 .dropdown-toggle").html(text);
    //////

    // var lastItem = $("#timeline li:nth-child("+count+")");
    // lastItem.clone().appendTo( "#timeline" )
    // console.log("count="+count);
    // console.log(lastItem.html());
    var activeElementPosition = $('#timeline li.active').position().top;
    $('#timeline').scrollTop($('#timeline').scrollTop() + activeElementPosition);

  });

  $("#timeline li a").click(function () {
    var activeElementPosition = $('#timeline li.active').position().top;
    $('#timeline').scrollTop($('#timeline').scrollTop());
  })

(function () {
  var WHATSAPP_CLASS = "squadkin-whatsapp-button";
  var WHATSAPP_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="40px" height="40px" aria-hidden="true" focusable="false"><circle cx="256" cy="256" r="256" fill="#59ce72"></circle><path d="M256 108c-88.37 0-160 64.47-160 144 0 46.46 24.64 87.79 63.31 114.73-3.15 22.18-12.78 46.22-38.64 63.78 24.59-1.28 72.96-10.45 101.44-42.34 11.08 2.37 22.56 3.83 33.89 3.83 88.37 0 160-64.47 160-144S344.37 108 256 108z" fill="#FFFFFF"></path></svg>';
  var NON_WHATSAPP_CHAT_SELECTORS = [
    "#sca-fg-today-offer-widget",
    "[id^='sca-fg-today-offer-widget']",
    ".sca-fg-count-offers",
    ".sca-today-offer-widget-right",
    ".tawk-min-container",
    "#tawkchat-container",
    "#tidio-chat",
    "#crisp-chatbox",
    ".intercom-lightweight-app",
    "#intercom-container",
    "#drift-widget-container",
    ".zsiq_floatmain",
    "iframe[src*='tawk.to']",
    "iframe[src*='tidio.co']",
    "iframe[src*='intercom']",
    "iframe[src*='drift.com']",
    "iframe[src*='crisp.chat']"
  ];

  function removeOtherChatWidgets() {
    NON_WHATSAPP_CHAT_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        node.remove();
      });
    });
  }

  function normalizeWhatsAppButton() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll("." + WHATSAPP_CLASS));
    if (!buttons.length) {
      return;
    }

    buttons.slice(1).forEach(function (node) {
      node.remove();
    });

    var button = buttons[0];
    button.classList.add("squadkin-wa-ready");
    button.setAttribute("aria-label", "WhatsApp Chat");
    button.setAttribute("title", "Chat on WhatsApp");
    button.innerHTML = WHATSAPP_SVG;

    if (button.tagName === "A") {
      button.setAttribute("target", "_blank");
      button.setAttribute("rel", "noopener noreferrer");
    }

    // Remove inline junk styles injected by third-party wrapper on the kept button.
    button.removeAttribute("style");
    var wrapper = button.closest(".squadkin-wrapper-container");
    if (wrapper) {
      Array.prototype.slice
        .call(wrapper.querySelectorAll("style"))
        .forEach(function (styleNode) {
          styleNode.remove();
        });
    }
  }

  var scheduled = null;
  function enforceSingleWhatsAppButton() {
    removeOtherChatWidgets();
    normalizeWhatsAppButton();
  }

  function scheduleEnforcement() {
    if (scheduled) {
      window.clearTimeout(scheduled);
    }
    scheduled = window.setTimeout(enforceSingleWhatsAppButton, 80);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enforceSingleWhatsAppButton);
  } else {
    enforceSingleWhatsAppButton();
  }

  var observer = new MutationObserver(scheduleEnforcement);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  var BOGOS_CONFIG = {
    productHandleKeywords: ["speciality-blend-south-indian"],
    activationTag: "bogos-active",
    tiers: [
      {
        key: "tier1",
        qty: 1,
        reward: "FREE Decoction Sachets",
        attributeValue: "decoction reward"
      },
      {
        key: "tier2",
        qty: 2,
        thresholdCents: 104000,
        reward: "FREE Cold Coffee",
        attributeValue: "1kg reward"
      }
    ]
  };
  var THRESHOLD_TIER = BOGOS_CONFIG.tiers.find(function (tier) {
    return typeof tier.thresholdCents === "number";
  }) || null;
  var LAST_ELIGIBLE_ATTR = { value: null };

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function inrFromCents(cents) {
    var rupees = Math.ceil(Math.max(0, cents) / 100);
    return "\u20B9" + rupees.toLocaleString("en-IN");
  }

  function isEligibleCartItem(item) {
    if (!item) {
      return false;
    }
    var handle = String(item.handle || "").toLowerCase();
    var handleMatched = BOGOS_CONFIG.productHandleKeywords.some(function (keyword) {
      return handle.indexOf(String(keyword).toLowerCase()) !== -1;
    });
    if (handleMatched) {
      return true;
    }
    var tagsRaw = String(item.product_tags || "");
    var tags = tagsRaw
      .split(",")
      .map(function (tag) {
        return tag.trim().toLowerCase();
      })
      .filter(Boolean);
    return tags.indexOf(BOGOS_CONFIG.activationTag.toLowerCase()) !== -1;
  }

  function getEligibleTierFromContext(context) {
    var qty = Number(context.qty || 0);
    var cartTotal = Number(context.cartTotalCents || 0);
    var unlocked = null;

    BOGOS_CONFIG.tiers.forEach(function (tier) {
      var meetsQty = qty >= tier.qty;
      var meetsThreshold = typeof tier.thresholdCents !== "number" || cartTotal >= tier.thresholdCents;
      if (meetsQty && meetsThreshold) {
        unlocked = tier;
      }
    });

    return unlocked;
  }

  function setEligibleOfferAttributes(value) {
    var normalizedValue = value || "";
    document.querySelectorAll(".js-bogos-eligible-offer-attr").forEach(function (input) {
      input.value = normalizedValue;
    });
    if (LAST_ELIGIBLE_ATTR.value === normalizedValue) {
      return;
    }
    LAST_ELIGIBLE_ATTR.value = normalizedValue;
  }

  function updateOfferWidget(widget, qty) {
    var normalizedQty = Number.isFinite(qty) && qty > 0 ? Math.floor(qty) : 1;
    var tier1 = widget.querySelector("[data-tier='1']");
    var tier2 = widget.querySelector("[data-tier='2']");
    var message = widget.querySelector(".js-bogos-offer-message");
    var unlockedTier = getEligibleTierFromContext({ qty: normalizedQty, cartTotalCents: Number.MAX_SAFE_INTEGER });

    if (tier1) {
      tier1.classList.toggle("is-unlocked", normalizedQty >= 1);
      tier1.classList.remove("is-upsell");
    }
    if (tier2) {
      tier2.classList.remove("is-unlocked");
      tier2.classList.remove("is-upsell");
      if (normalizedQty >= 2) {
        tier2.classList.add("is-unlocked");
      } else {
        tier2.classList.add("is-upsell");
      }
    }

    if (message) {
      if (unlockedTier && unlockedTier.key === "tier2") {
        message.textContent = "\uD83C\uDF89 You unlocked FREE Cold Coffee!";
        widget.setAttribute("data-state", "unlocked");
      } else {
        message.textContent = "Add 1 more pack to unlock FREE Cold Coffee \u2615";
        widget.setAttribute("data-state", "upsell");
      }
    }
  }

  function bindOfferWidget(widget) {
    var productBox = widget.closest(".product-single__box");
    var form = productBox ? productBox.querySelector("form.js-product-form") : document.querySelector("form.js-product-form");
    var qtyInput = form ? form.querySelector("input[name='quantity']") : null;
    if (!qtyInput) {
      return;
    }

    var sync = function () {
      var qty = parseInt(qtyInput.value, 10);
      updateOfferWidget(widget, qty);
    };

    qtyInput.addEventListener("input", sync);
    qtyInput.addEventListener("change", sync);

    // Support custom +/- controls that update quantity indirectly.
    document.addEventListener("click", function (event) {
      if (event.target.closest(".qtyplus, .qtyminus, .js-qty__adjust, .ajaxcart__qty-adjust")) {
        window.setTimeout(sync, 30);
      }
    });

    sync();
  }

  function initOfferWidgets() {
    var widgets = document.querySelectorAll(".js-bogos-offer-widget");
    var appVolumeWidget = document.querySelector("#bogos-volume-discount-view .bogos-volume-discount-widget");

    if (appVolumeWidget) {
      widgets.forEach(function (widget) {
        widget.style.display = "none";
      });
      return;
    }

    widgets.forEach(function (widget) {
      if (!widget.dataset.bound) {
        widget.dataset.bound = "true";
        bindOfferWidget(widget);
      }
    });

    if (widgets.length) {
      widgets[0].id = "bogos-volume-discount-view";
      for (var i = 1; i < widgets.length; i++) {
        widgets[i].style.display = "none";
      }
    }
  }

  var FREE_DELIVERY_THRESHOLD_CENTS = 49900;

  function updateFreeDeliveryUI(cart) {
    var els = document.querySelectorAll(".js-free-delivery-progress");
    if (!els.length || !cart) return;

    var total = Number(cart.total_price || 0);
    var remaining = Math.max(0, FREE_DELIVERY_THRESHOLD_CENTS - total);
    var percent = clamp((total / FREE_DELIVERY_THRESHOLD_CENTS) * 100, 0, 100);
    var unlocked = total >= FREE_DELIVERY_THRESHOLD_CENTS;
    var message = unlocked
      ? "\uD83C\uDF89 You\u2019ve unlocked FREE Delivery!"
      : "You\u2019re " + inrFromCents(remaining) + " away from FREE Delivery \uD83D\uDE9A";

    if (!cart.item_count && !unlocked) {
      message = "Add \u20B9499 worth of products for FREE Delivery \uD83D\uDE9A";
    }

    els.forEach(function (el) {
      el.setAttribute("data-state", unlocked ? "unlocked" : "pending");
      var messageEl = el.querySelector(".js-free-delivery-message");
      var fillEl = el.querySelector(".js-free-delivery-fill");
      if (messageEl) messageEl.textContent = message;
      if (fillEl) fillEl.style.width = percent.toFixed(2) + "%";
    });
  }

  function updateCartProgressUI(cart) {
    updateFreeDeliveryUI(cart);
    var progressEls = document.querySelectorAll(".js-bogos-cart-progress");
    var checkoutNoteEls = document.querySelectorAll(".js-bogos-checkout-note");
    if ((!progressEls.length && !checkoutNoteEls.length) || !cart) {
      return;
    }

    var eligibleItems = Array.isArray(cart.items) ? cart.items.filter(isEligibleCartItem) : [];
    var hasEligibleItem = eligibleItems.length > 0;
    var eligibleQty = eligibleItems.reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
    var total = Number(cart.total_price || 0);
    var unlockedTier = getEligibleTierFromContext({ qty: eligibleQty, cartTotalCents: total });
    var remaining = THRESHOLD_TIER ? Math.max(0, THRESHOLD_TIER.thresholdCents - total) : 0;
    var percent = THRESHOLD_TIER ? clamp((total / THRESHOLD_TIER.thresholdCents) * 100, 0, 100) : 100;
    var unlockedThreshold = THRESHOLD_TIER ? total >= THRESHOLD_TIER.thresholdCents : false;
    var messageText = unlockedThreshold
      ? "\uD83C\uDF89 You unlocked FREE Cold Coffee!"
      : "You're " + inrFromCents(remaining) + " away from FREE Cold Coffee \u2615";
    var rewardText = unlockedTier
      ? "Eligible reward: " + unlockedTier.reward
      : "No active BOGOS reward yet";

    setEligibleOfferAttributes(unlockedTier ? unlockedTier.attributeValue : "");

    progressEls.forEach(function (el) {
      if (!hasEligibleItem || !cart.item_count) {
        el.classList.add("bogos-cart-progress--hidden");
        return;
      }

      el.classList.remove("bogos-cart-progress--hidden");
      el.setAttribute("data-state", unlockedThreshold ? "unlocked" : "pending");

      var messageEl = el.querySelector(".js-bogos-cart-progress-message");
      var fillEl = el.querySelector(".js-bogos-cart-progress-fill");

      if (messageEl) {
        messageEl.textContent = messageText;
      }
      if (fillEl) {
        fillEl.style.width = percent.toFixed(2) + "%";
      }
    });

    checkoutNoteEls.forEach(function (el) {
      var rewardEl = el.querySelector(".js-bogos-eligible-reward");
      if (!hasEligibleItem || !cart.item_count) {
        el.classList.add("bogos-cart-progress--hidden");
      } else {
        el.classList.remove("bogos-cart-progress--hidden");
      }
      if (rewardEl) {
        rewardEl.textContent = rewardText;
      }
    });

    document.querySelectorAll(".js-bogos-line-message").forEach(function (lineMessage) {
      lineMessage.textContent = rewardText;
    });
  }

  function fetchCartAndUpdateProgress() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Failed to fetch cart");
        }
        return response.json();
      })
      .then(updateCartProgressUI)
      .catch(function () {
        // no-op
      });
  }

  var cartRefreshTimer = null;
  function scheduleCartProgressRefresh() {
    window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(fetchCartAndUpdateProgress, 120);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initOfferWidgets();
      fetchCartAndUpdateProgress();
    });
  } else {
    initOfferWidgets();
    fetchCartAndUpdateProgress();
  }

  document.addEventListener("change", function (event) {
    if (event.target.matches("input[name='updates[]'], .ajaxcart__qty-num")) {
      scheduleCartProgressRefresh();
    }
  });

  document.addEventListener("input", function (event) {
    if (event.target.matches("input[name='updates[]'], .ajaxcart__qty-num")) {
      scheduleCartProgressRefresh();
    }
  });

  if (window.jQuery) {
    window.jQuery(document.body).on(
      "afterAddItem.ajaxCart afterChangeItem.ajaxCart afterCartLoad.ajaxCart",
      scheduleCartProgressRefresh
    );
  }
})();
